import React from 'react'
import { useSelector } from 'react-redux'
import styles from './Presets.module.scss'
import ExportColors from './ExportColors'
import ImportColors from './ImportColors'
import { useComponentLocale } from '../../../../../hooks/useComponentLocale'
import { selectPreferences } from '../../../../../Redux/selectors/selectors'
import { useActions } from '../../../../../hooks/useActions'
import PreviewColorLine from '../PreviewPresets/PreviewColorLine'
import { sortedOrderPositionsFromObj } from '../../../../../helpers/helpers'
import { getRenderData } from '../utils'
import { Scrollbars } from 'react-custom-scrollbars'

const mapper = [
	{ type: '', property: 'actions' },
	{ type: 'matrix', property: 'range' },
	{ type: 'matrix', property: 'ev' },
	{ type: 'matrix', property: 'equity' },
	{ type: '', property: 'positions' },
	{ type: 'cards', property: 'suits' },
	{ type: 'trainer', property: 'table' },
]

function Presets() {
	const {
		currentPreset,
		dataNew: { presets },
	} = useSelector(selectPreferences)
	const { setAppliedPreset } = useActions()

	const getLocale = useComponentLocale()

	// const presetsLocale = getLocale({ component: 'theme', section: 'presets_sign' })
	// const sharePresetsTextLocale = getLocale({ component: 'theme', section: 'share_preset_text' })
	const discordLinkLocale = getLocale({ component: 'links', section: 'discord' })

	return (
		<div className={styles.presetsWrapper}>
			<div>
				<span>
					Share your awesome styles with our community in #presets channel on{' '}
					<a href='https://discord.gg/4xhymv3WbB' rel='noreferrer' target='_blank'>
						our {discordLinkLocale}
					</a>
				</span>

				<div>
					<Scrollbars
						renderTrackHorizontal={(props) => <div {...props} style={{ display: 'none' }} />}
						renderThumbVertical={({ style, ...props }) => (
							<div
								{...props}
								style={{ ...style, backgroundColor: '#5a6268', borderRadius: '3px', marginRight: '5px' }}
							/>
						)}
					>
						<div className={styles.presetsButtons}>
							{presets.map(({ key: presetName, value: presetOptions }) => {
								return (
									<div
										key={presetName}
										className={
											presetName === currentPreset ? styles.presetViewWrapperSelected : styles.presetViewWrapper
										}
									>
										<span>{presetName}</span>

										<div onClick={() => setAppliedPreset(presetOptions)}>
											{mapper.map((item) => {
												const type = item.type
												const property = item.property
												let renderData

												if (property === 'positions') {
													const sortedPositions = {
														...presetOptions,
														positions: sortedOrderPositionsFromObj(presetOptions.positions),
													}

													renderData = getRenderData(sortedPositions, type, property)
												} else if (type === 'trainer') {
													renderData = [['', presetOptions.trainer.table]]
												} else {
													renderData = getRenderData(presetOptions, type, property)
												}

												return (
													<PreviewColorLine
														key={item.property}
														renderData={renderData}
														isClassName={false}
														property={item.property}
														preset={presetOptions}
														text={item.type === 'cards' ? 'Q' : ''}
													/>
												)
											})}
										</div>
									</div>
								)
							})}
						</div>
					</Scrollbars>
				</div>
			</div>

			<div className={styles.inputContainer}>
				<ExportColors />

				<ImportColors />
			</div>
		</div>
	)
}

export default Presets
